// Taken from https://stackoverflow.com/a/53230807
import axios from 'axios';

const dowloadFileFromUrl = async (url: string, fileName: string) => {
  // Get file data
  const { data } = await axios({ url, method: 'GET', responseType: 'blob' });

  // Create a file link in browser's memory.
  const href = URL.createObjectURL(data);

  // Create a downloadable anchor element to the file link and click it.
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();

  // Clean up to prevent memory leaks.
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export default dowloadFileFromUrl;
